import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row container-fluid mt-2 d-flex w-100 ssss" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Produits commander")
], -1)
const _hoisted_4 = { class: "col-md-12 mb-2" }
const _hoisted_5 = { class: "table-responsive w-100" }
const _hoisted_6 = { class: "table table-bordered" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nom du produit"),
    /*#__PURE__*/_createElementVNode("th", null, "Coût unitaire"),
    /*#__PURE__*/_createElementVNode("th", null, "Total")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "text-left"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-decoration-line-through mb-0" }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order?.elements_order, (elementOrder) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: elementOrder.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("b", null, _toDisplayString(elementOrder.quantity) + " x " + _toDisplayString(elementOrder?.finalName), 1),
                  ((elementOrder.sub_elements_order && elementOrder.sub_elements_order.length > 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementOrder.sub_elements_order, (subElement) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subElement.id
                          }, [
                            (subElement.type == 'ing')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                  (subElement?.sub_product?.group?.max != null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(subElement.sub_product?.name), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(subElement.sub_product?.name), 1))
                                ]))
                              : _createCommentVNode("", true),
                            (subElement.type == 'sup')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(subElement.quantity) + " x " + _toDisplayString(subElement.sub_product?.name) + " " + _toDisplayString(subElement.price.toFixed(2)) + " € ", 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(elementOrder?.unitePrice ?? 0) + " € ", 1),
                _createElementVNode("td", null, [
                  (elementOrder?.discountPromotion)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(elementOrder?.discountPromotion?.totalPriceWithoutDiscount?.toFixed(2)), 1),
                        _createElementVNode("span", null, _toDisplayString(elementOrder?.discountPromotion?.discount?.toFixed(2)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!elementOrder?.discountPromotion)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(elementOrder.total_amount_element_subelements?.toFixed(2)) + " € ", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}